'use client'

import { useInitApp } from './useInitApp'
import { ReactNode } from 'react'

interface Props {
  children?: ReactNode
}

export default function InitAppWrapper({ children }: Props) {
  useInitApp()

  // 쿠키 설정
  // TODO: 아 이거 필요없는거 같은데...나중에 시간나면 제거
  if (typeof window !== 'undefined') {
    const platform = process.env.NEXT_PUBLIC_PLATFORM || 'PC'
    if (!document.cookie.includes('platform=')) {
      document.cookie = `platform=${platform};path=/;max-age=${365 * 24 * 60 * 60}`
    }
  }

  return children || null
}